import { UserRole } from "tm-shared/types";

import { isManagerRole } from "@/utils/business/isManagerRole";

export interface CheckoutCapabilities {
    isManager: boolean;
    canBypassWorkStatusCheck: boolean;
    canCopyAgentContact: boolean;
}

export const getCheckoutCapabilities = (
    role: UserRole,
): CheckoutCapabilities => {
    const isManager = isManagerRole(role);

    return {
        isManager,
        canBypassWorkStatusCheck: isManager,
        canCopyAgentContact: isManager,
    };
};
